import React from "react";
const Variables = () => {
    return (

        <div >
            <h3 id="variables">Variables</h3>
            <p>
                <p>
                    It’s often useful to store the value of a calculation or another computed result
                    somewhere to use it later (perhaps in another calculation). In the Variables toolbox
                    category, you can create a new variable to store intermediate values to re-use
                    elsewhere in your script.
                </p>

                <div className="imageContainer">
                    <img src="images/createVariables.gif" alt="Create Variables" />
                </div>

                <p>
                    <b>Note</b>: When creating a variable, three new blocks are added to the Variables toolbox category:

                    <ul>

                        <li>A block for setting the value of a variable</li>
                        <li>A block for getting the value of a variable</li>
                        <li>A block for incrementing the value of a variable by 1</li>

                    </ul>

                </p>

                <p>
                    Here&#39;s an example of where you might want to use a variable. If you have a
                    complicated calculation that requires many math blocks, chances are your block is
                    long and difficult to read. The first block below calculates the total price of a food
                    order by adding the prices of each individual menu item together.
                </p>

                <div className={'imageContainer'}>
                    <img src='images/mathLong.png' alt="Math Long" />
                </div>

                <p>
                    With variables, you can split the calculation into a few steps where you update the
                    value of the variable you use to store intermediate values.
                </p>

                <div className={'imageContainer'}>
                    <img src='images/mathVariables.png' alt="Math Variables" />
                </div>

                With variables, the script is now easier to read and understand.
            </p>

            <h4>Global Variables</h4>
            <p>
                Global variables are accessible throughout your whole app, across different scripts.
                They are useful when you need to share data between different parts of
                your logic or maintain state across multiple actions.
            </p>

            <div className="imageContainer">
                <img src="images/global_variables.png" alt="Global variables example" />
            </div>

            <p>
                To create a global variable in Snap, go to the <b>Data Connection Rules</b> section, then
                navigate to <b>Global Variables</b>. From there, you can define variables that will be
                available across your entire app.
            </p>

            <p>
                Be cautious when using global variables, as they can be modified from anywhere in your
                app, which might lead to unexpected behaviour if not managed carefully.
            </p>

        </div>
    );

}

export default Variables;
